import { takeLatest, put, call, takeEvery } from 'redux-saga/effects';

import { LOADER_CLOSE, LOADER_OPEN } from '../actions';
import {} from '../actions/news';
import {
  LIVE_EVENTS_GET,
  QUIZ_ATTEMPTS_SET,
  QUIZ_VISIBILITY_SET,
  SESSION_RESULT_EXPORT,
  SESSION_RESULT_GET,
  SESSION_USERS_GET,
  USERS_ATTENDANCE_SET,
} from '../actions/liveEvent';
import courselist from '../../api/courselist';
import liveEvents from '../../api/liveEvents';
import { COURSE_DETAILS_GET } from '../actions/coursedetails';
import { errorHandling, genericErrorToast } from '../../../utils/errors';

function* liveEventsGet({ filters = {}, isToday }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      courselist.getCoursesList,
      filters
    );
    yield put({ type: LIVE_EVENTS_GET._SUCCESS, response, isToday });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > liveEvent > liveEventsGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* liveEventsGetWatch() {
  yield takeEvery(LIVE_EVENTS_GET._REQUEST, liveEventsGet);
}

function* sessionUsersGet({ session_id, activity_id, filters = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      liveEvents.sessionUsersGet,
      { session_id, activity_id, filters }
    );
    yield put({ type: SESSION_USERS_GET._SUCCESS, activity_id, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > liveEvent > sessionUsersGet', err);
    errorHandling(err);
    yield put({ type: SESSION_USERS_GET._ERROR, activity_id });
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* sessionUsersGetWatch() {
  yield takeEvery(SESSION_USERS_GET._REQUEST, sessionUsersGet);
}

function* usersAttendanceSet({ session_id, activity_id, body = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      liveEvents.usersAttendanceSet,
      { session_id, activity_id, body }
    );
    yield put({ type: USERS_ATTENDANCE_SET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > liveEvent > usersAttendanceSet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* usersAttendanceSettWatch() {
  yield takeLatest(USERS_ATTENDANCE_SET._REQUEST, usersAttendanceSet);
}

function* quizAttemptsSet({ session_id, tentatives, event_id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      liveEvents.quizAttemptsSet,
      { session_id, body: { tentatives } }
    );
    yield put({ type: QUIZ_ATTEMPTS_SET._SUCCESS, response });
    yield put({ type: COURSE_DETAILS_GET._REQUEST, id: event_id });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > liveEvent > quizAttemptsSet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* quizAttemptsSetWatch() {
  yield takeLatest(QUIZ_ATTEMPTS_SET._REQUEST, quizAttemptsSet);
}

function* quizVisibilitySet({ session_id, visibility, event_id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      liveEvents.quizVisibilitySet,
      { session_id, body: { visibility } }
    );
    yield put({ type: QUIZ_VISIBILITY_SET._SUCCESS, response });
    yield put({ type: COURSE_DETAILS_GET._REQUEST, id: event_id });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > liveEvent > quizVisibilitySet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* quizVisibilitySetWatch() {
  yield takeLatest(QUIZ_VISIBILITY_SET._REQUEST, quizVisibilitySet);
}

function* getSessionResult({ id, filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      liveEvents.getSessionResult,
      id,
      filters
    );
    yield put({ type: SESSION_RESULT_GET._SUCCESS, response });
  } catch (error) {
    yield put({ type: SESSION_RESULT_GET._ERROR, error });
    // eslint-disable-next-line no-console
    console.log('sagas > events > getSessionResult', error);
    errorHandling(error);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* getSessionResultWatch() {
  yield takeLatest(SESSION_RESULT_GET._REQUEST, getSessionResult);
}

function* sessionResultExport({ sessionId }) {
  try {
    yield put({ type: LOADER_OPEN });
    const err = yield call(liveEvents.sessionResultExport, sessionId);
    if (err?.message) throw Error(err);
    else {
      yield put({ type: SESSION_RESULT_EXPORT._SUCCESS });
    }
  } catch (error) {
    yield put({ type: SESSION_RESULT_EXPORT._ERROR, error });
    // eslint-disable-next-line no-console
    console.log('sagas > events > sessionResultExport', error);
    genericErrorToast();
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* sessionResultExportWatch() {
  yield takeLatest(SESSION_RESULT_EXPORT._REQUEST, sessionResultExport);
}

export default [
  liveEventsGetWatch(),
  sessionUsersGetWatch(),
  usersAttendanceSettWatch(),
  quizAttemptsSetWatch(),
  quizVisibilitySetWatch(),
  getSessionResultWatch(),
  sessionResultExportWatch(),
];
